import React, { useState } from 'react';
import { useIntl } from 'umi';
import WhiteTick from '../../../svg/white-tick.svg';
import DS1 from '@/pages/aigc/assets/ds-image1.png';
import DefaultAvatar from '@/pages/aigc/assets/svg/default-avatar.svg';
import CommonBubble from '@home/components/CommonBubble';
import BasicImage from '@home/components/BasicImage';
import { PERMISSION_URL } from '../../../config/constant';
import '../DSExpertAgentCard/index.scss';

export interface ICopilotCardProps {
  hasPermission?: boolean;
  title: string;
  content: string;
  author: { name: string; img: string; };
  diagram: string;
  isSelected: boolean;
  handleOnClick?: () => void;
}

const CopilotCard = ({
  hasPermission = false,
  title,
  content,
  author,
  diagram,
  isSelected,
  handleOnClick,
}: ICopilotCardProps) => {
  const { formatMessage, locale } = useIntl();
  const [imgErr, setImgErr] = useState(false);

  return (
    <CommonBubble
      overlayClassName='dba-nav-menu-overlay'
      className='dba-ds-expert-card-bubble-box'
      placement="top"
      content={hasPermission ? null : <>{formatMessage({id: 'dba_no_permission_desc'})}<a href={PERMISSION_URL} target="_blank" rel="noreferrer">{PERMISSION_URL}</a></>}
    >
      <div
        className={`dba-copilot-ds-template-card ${isSelected ? 'dba-copilot-ds-template-card-selected' : ''} ${!hasPermission ? 'dba-copilot-ds-template-card-disabled' : ''}`}
        onClick={hasPermission ? handleOnClick : undefined}
      >
        {/* 左侧图片 */}
        <img
          src={imgErr ? DS1 : diagram}
          className="dba-copilot-ds-template-card-diagram"
          draggable={false}
          onError={() => setImgErr(true)}
          alt="Template Preview"
        />

        {/* 右侧内容区域 */}
        <div className="dba-copilot-ds-template-card-content">
          <div className="dba-copilot-ds-template-card-title">{title}</div>
          <div className="dba-copilot-ds-template-card-desc">{content}</div>
          <div className="dba-copilot-ds-template-card-author">
            <BasicImage 
              src={author.img || DefaultAvatar} 
              errorSrc={DefaultAvatar} 
              alt="Author" 
            />
            <span>{author.name}</span>
          </div>
        </div>

        {/* 权限标识角标 */}
        <span className="dba-copilot-ds-permission-badge" data-has-permission={hasPermission} data-eng-locale={locale === 'en-US'}>
          {hasPermission ? (isSelected ? <img src={WhiteTick} alt="Got Permission Tick" draggable={false} /> : null) : formatMessage({ id: 'dba_no_permission' })}
        </span>
      </div>
    </CommonBubble>
  );
};

export default CopilotCard;
